import * as React from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import  Login from './components/Login';
import Main from './components/Main';
import ResetPassword from './components/ResetPassword';
import ContactUs from './components/login/contactus';
import Unauthorized from './components/unauthorized';
import PdfReport from './components/PdfReport';
// import Terms from './components/login/terms';
// import PrivacyPolicy from './components/login/privacypolicy';
// import Organizations from './components/Organizations';
// import Profiles from './components/Profiles';
// import Tests from './components/Tests';
// import Users from './components/Users';
import ExternalLogin from '../src/components/external/Login';
import ViewTest from '../src/components/test/ViewTest';
import ForgotPassword from '../src/components/login/forgotPassword';
import './App.scss';
// import ZendeskLogin  from '../src/components/ZendeskLogin';
// import ZendeskRedirect  from '../src/components/ZendeskRedirect';

class App extends React.Component {
  render() {
    return (
      <Router>
        <Switch>
          <Route  path="/unauthorized" render={(props) => <Unauthorized {...props}/>} />
          <Route  path="/pdfreport" render={(props) => <PdfReport {...props}/>} />
          <Route path={'/viewtest/' + ':testid/:rta?'} render={(props) => <ViewTest {...props}/>}/>
          {/* <Route  path="/user" component={Users} /> */}
          {/* <Route  path="/organization" component={Organizations} /> */}
          {/* <Route  path="/profile" component={Profiles} /> */}
          {/* <Route  path="/test" component={Main} /> */}
          {/* <Route  path="/zendeskredirect" component={ZendeskRedirect} />          
          <Route  path="/support/sso" component={ZendeskLogin} />
          <Route  path="/zendesklogin" component={ZendeskLogin} /> */}
          <Route  path={'/external/home/' + ':shareuserid' + '/' + ':shareid'} render={(props) => <Main {...props}/>}/>
          <Route  path="/login" component={Login} />
          {/*<Route  path="/privacy" component={PrivacyPolicy} />*/}
          {/*<Route  path="/terms" component={Terms} />*/}
          <Route  path="/contactus" component={ContactUs} />
          <Route  
                path={'/external/login/' + ':shareuserid/:shareid/:flag'} 
                render={(props: any) => 
                  <ExternalLogin {...props} />                    
                }
          />
          
          <Route  path={'/resetPassword/' + ':tokenid'} render={(props) => <ResetPassword {...props}/>}/>
          <Route  path={'/createAccount/' + ':tokenid'} render={(props) => <ResetPassword {...props}/>}/>
          <Route  path={'/forgotUsername'} render={(props) => <ForgotPassword {...props}/>}/>
          <Route  path={'/forgotPassword'} render={(props) => <ForgotPassword {...props}/>}/>
          <Route  path="/" render={(props) => <Main {...props}/>}/>
        </Switch>
      </Router> 
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.tsx